import React, { useEffect, useState } from "react";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
// import Copyright from "../common/footer/Copyright";
import "../common/styles/panel.css";
import { useTranslation } from "react-i18next";

const Service = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 576px)');
    const handleChange = (e) => setIsMobile(e.matches);
    handleChange(mq);
    mq.addEventListener ? mq.addEventListener('change', handleChange) : mq.addListener(handleChange);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', handleChange) : mq.removeListener(handleChange);
    };
  }, []);
  
  return (
    <>
      <SEO title="Service - Cyberate Investments" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        <div className="container page-content-text" style={{ paddingTop: isMobile ? 24 : 40, paddingBottom: isMobile ? 40 : 60 }}>
          <h1 className="cy-section-title text-center service-page-title" style={{ color: '#fff', margin: isMobile ? '32px 0 32px 0' : '60px 0 60px 0', fontSize: isMobile ? '36px' : '60px' }}>{t("service.title")}</h1>

          {/* Panel 1: Property Investment Strategy */}
          <div className="cy-panel cy-panel--p40 service-card-mobile-center" style={{ marginBottom: 28 }}>
            {/* <h3 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 30 }}>{t("service.property_investment_strategy.title")}</h3> */}
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <div className="service-icon-wrapper" style={{ marginBottom: 20, textAlign: 'left' }}>
                  <div className="service-icon" style={{ 
                    width: 90, 
                    height: 90, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    margin: '0 0 15px 0'
                  }}>
                    <img src="/images/icons/7.png" alt="Service Icon" style={{ width: 90, height: 90 }} />
                  </div>
                </div>
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15, textAlign: 'left' }}>{t("service.property_investment_strategy.who_its_for")}</h6>
                <p className="cy-text-muted" style={{ textAlign: 'left', fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>{t("service.property_investment_strategy.who_its_for_desc")}</p>
              </div>
              <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                <div className="cy-panel__divider" />
              </div>
              <div className="col-lg-5 text-center">
                <div className="service-icon-wrapper" style={{ marginBottom: 20, textAlign: 'left' }}>
                  <div className="service-icon" style={{ 
                    width: 90, 
                    height: 90, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    margin: '0 0 15px 0'
                  }}>
                    <img src="/images/icons/6.png" alt="Service Icon" style={{ width: 90, height: 90 }} />
                  </div>
                </div>
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15, textAlign: 'left' }}>{t("service.property_investment_strategy.what_we_do")}</h6>
                <ul className="cy-service-list" style={{ listStyle: 'none', padding: 0, textAlign: 'left', fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>
                  <li className="cy-text-muted">{t("service.property_investment_strategy.what_we_do_items.0")}</li>
                  <li className="cy-text-muted">{t("service.property_investment_strategy.what_we_do_items.1")}</li>
                  <li className="cy-text-muted">{t("service.property_investment_strategy.what_we_do_items.2")}</li>
                  <li className="cy-text-muted">{t("service.property_investment_strategy.what_we_do_items.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Panel 2: First Home Buyer Advisory */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28 }}>
            <h3 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 30 }}>{t("service.first_home_buyer_advisory.title")}</h3>
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15 }}>{t("service.first_home_buyer_advisory.who_its_for")}</h6>
                <p className="cy-text-muted" style={{ fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>{t("service.first_home_buyer_advisory.who_its_for_desc")}</p>
              </div>
              <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                <div className="cy-panel__divider" />
              </div>
              <div className="col-lg-5 text-center">
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15 }}>{t("service.first_home_buyer_advisory.what_we_do")}</h6>
                <ul className="cy-service-list" style={{ listStyle: 'none', padding: 0, textAlign: 'center', fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>
                  <li className="cy-text-muted">{t("service.first_home_buyer_advisory.what_we_do_items.0")}</li>
                  <li className="cy-text-muted">{t("service.first_home_buyer_advisory.what_we_do_items.1")}</li>
                  <li className="cy-text-muted">{t("service.first_home_buyer_advisory.what_we_do_items.2")}</li>
                  <li className="cy-text-muted">{t("service.first_home_buyer_advisory.what_we_do_items.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Panel 3: Investment Partnership & Co-Investment */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28 }}>
            <h3 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 30 }}>{t("service.investment_partnership.title")}</h3>
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <div className="service-icon-wrapper" style={{ marginBottom: 20 }}>
                  <div className="service-icon" style={{ 
                    width: 90, 
                    height: 90, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    margin: '0 auto 15px'
                  }}>
                    <img src="/images/icons/9.png" alt="Service Icon" style={{ width: 90, height: 90 }} />
                  </div>
                </div>
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15 }}>{t("service.investment_partnership.who_its_for")}</h6>
                <p className="cy-text-muted" style={{ fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>{t("service.investment_partnership.who_its_for_desc")}</p>
              </div>
              <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                <div className="cy-panel__divider" />
              </div>
              <div className="col-lg-5 text-center">
                <div className="service-icon-wrapper" style={{ marginBottom: 20 }}>
                  <div className="service-icon" style={{ 
                    width: 90, 
                    height: 90, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    margin: '0 auto 15px'
                  }}>
                    <img src="/images/icons/8.png" alt="Service Icon" style={{ width: 90, height: 90 }} />
                  </div>
                </div>
                <h6 className="cy-text-gold" style={{ fontWeight: 700, marginBottom: 15 }}>{t("service.investment_partnership.what_we_do")}</h6>
                <ul className="cy-service-list" style={{ listStyle: 'none', padding: 0, textAlign: 'center', fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>
                  <li className="cy-text-muted">{t("service.investment_partnership.what_we_do_items.0")}</li>
                  <li className="cy-text-muted">{t("service.investment_partnership.what_we_do_items.1")}</li>
                  <li className="cy-text-muted">{t("service.investment_partnership.what_we_do_items.2")}</li>
                  <li className="cy-text-muted">{t("service.investment_partnership.what_we_do_items.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Panel 4: Global Property Strategy Support */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28 }}>
            <h3 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 30 }}>{t("service.global_property_strategy.title")}</h3>
            <div className="row align-items-center">
              <div className="col-lg-6 text-center" style={{ marginBottom: isMobile ? 16 : undefined }}>
                <img src="/images/service/图片3.png" alt="Service" style={{ height: isMobile ? 160 : 200, width: '100%', objectFit: 'none', }} />
              </div>
              <div className="col-lg-6 text-center">
                <p className="cy-text-muted" style={{  fontSize: isMobile ? 14 : 18, textAlign: 'left', lineHeight: '1.6' }}>
                  {t("service.global_property_strategy.who_its_for_desc")}
                </p>
              </div>
            </div>
          </div>

          {/* Panel 5: What we do */}
          <div className="cy-panel cy-panel--p40 cy-panel-what-we-do" style={{ marginBottom: isMobile ? 20 : 28, paddingLeft: isMobile ? '0' : '20%' }}>
            <div className="cy-bullet-title">
              <span className="cy-bullet-title__dot"></span>
              <h3 className="cy-bullet-title__text">{t("service.global_property_strategy.what_we_do_title")}</h3>
            </div>
            <ul className="cy-bullets" style={{ fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? '1.6' : undefined }}>
              <li>{t("service.global_property_strategy.what_we_do_items.0")}</li>
              <li>{t("service.global_property_strategy.what_we_do_items.1")}</li>
              <li>{t("service.global_property_strategy.what_we_do_items.2")}</li>
              <li>{t("service.global_property_strategy.what_we_do_items.3")}</li>
              <li>{t("service.global_property_strategy.what_we_do_items.4")}</li>
            </ul>
          </div>

          {/* Panel 6: Global Property Strategy Support (Second) */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28 }}>
            <div className="row align-items-center">
              <div className="col-lg-6 text-center" style={{ marginBottom: isMobile ? 16 : undefined }}>
                <p className="cy-text-muted" style={{ textAlign: 'left', fontSize: isMobile ? 14 : 18, lineHeight: '1.6' }}>
                  {t("service.global_property_strategy.description_1")}
                </p>
                <p className="cy-text-muted" style={{ textAlign: 'left', fontSize: isMobile ? 14 : 18, lineHeight: '1.6'}}>
                  {t("service.global_property_strategy.description_2")}
                </p>
              </div>
              <div className="col-lg-6 text-center">
                <img src="/images/service/图片5.png" alt="Service" style={{ height: isMobile ? 160 : 200, width: '100%', objectFit: 'none' }} />
              </div>
            </div>
          </div>
        </div>

        <FooterTwo />
        {/*  {/* <Copyright /> */}
      </main>
    </>
  );
};

export default Service;
